import React from 'react';
import { AddLayoutForm } from './components';
import BaseLayout from '@/shared/components/layout/BaseLayout';

export const AddLayoutPage: React.FC = () => {
  return (
    <BaseLayout>
      <div className="container mx-auto max-w-4xl py-8 px-4">
        <AddLayoutForm />
      </div>
    </BaseLayout>
  );
};


